// extracted by mini-css-extract-plugin
export default {"header":"DocumentCenterInformationTab_header__jSQYG","tab":"DocumentCenterInformationTab_tab__-fnBt","tab__title":"DocumentCenterInformationTab_tab__title__qXIDH font-xl-medium"};